import React, { useRef, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Field from "egov-ui-kit/utils/field";
import CaptchaBackground from "../../../../../../kmcAssets/img/captchaBG.jpg";
import LOGO from "../../../../../../kmcAssets/img/kmclogo.png";
import { Card, Image, Icon } from "components";
import { Button } from "egov-ui-framework/ui-atoms";
import Label from "egov-ui-kit/utils/translationNode";
import { startSMSRecevier } from "egov-ui-kit/utils/commons";
import Hidden from "@material-ui/core/Hidden";
import logo from "egov-ui-kit/assets/images/logo_black.png";
import "./index.css";
import kmcLogo from "../../../../../../kmcAssets/img/logo-login.png";
import "../../../../../../kmcAssets/css/style-login.css";
// import "../../../../../../kmcAssets/css/style.css";
import "../../../../../../kmcAssets/css/property-tax-design.css";
import "../../../../../../kmcAssets/css/main.css";
import store from "ui-redux/store";
import { setFieldProperty } from "egov-ui-kit/redux/form/actions";

const LoginForm = ({ handleFieldChange, form, logoUrl, qrCodeURL, enableWhatsApp }) => {
  const [generatedCaptcha, setGeneratedCaptcha] = useState("");
  const [disabled, setDisabled] = React.useState(true);
  const fields = form.fields || {};
  const submit = form.submit;
  let captcha;
  let alphabets = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";

  const captchaInputRef = useRef();

  const generate = () => {
    let first = Math.floor(Math.random() * 10);;
    let second = Math.floor(Math.random() * 10);
    let third = Math.floor(Math.random() * 10);
    let fourth = Math.floor(Math.random() * 10);;
    let fifth = Math.floor(Math.random() * 10);;
    let sixth = Math.floor(Math.random() * 10);

    captcha = first.toString() + second.toString() + third.toString() + fourth.toString() + fifth.toString() + sixth.toString();

    localStorage.setItem("captcha", captcha);
    store.dispatch(setFieldProperty("login", "generatedCaptcha", "value", captcha));
    setGeneratedCaptcha(captcha);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Tab" && disabled) {
      e.preventDefault();
    }
  };
  useEffect(() => {
    generate();
  }, []);

  return (
    <div>
      <div className="login-left">
        <div className="container">
          <div className="row">
            <div className="logo-ad col-lg-12">
              <img src={kmcLogo} />
            </div>
            <span className="border-b"></span>
          </div>
        </div>
        <div className="col-lg-12 text-center kmc-logo-container">
          <img style={{ marginTop: "50px" }} src={LOGO} />
        </div>
      </div>

      <div className="login-right" style={{ height: "100vh" }}>
        <div className="ad-logo">
          <h2>Citizen login </h2>
          {/* <span className="border-r"></span> */}
          <h3>Welcome back! Please login to your account .</h3>
        </div>
        <div className="center login">
          <div className="login__field">
            <Field fieldKey="phone" field={fields.phone} handleFieldChange={handleFieldChange} />
            {/* <input type="text" className="login__input" placeholder="Employee ID" /> */}
          </div>
          <div className="login__field">
            {/* Captcha Text */}
            <div className="row mt-1">
              <div className="col-10">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "10px",
                    justifyContent: "space-between",
                  }}
                >
                  <img
                    src={CaptchaBackground}
                    alt="captcha background"
                    style={{
                      objectFit: "cover",
                      height: "41px",
                      width: "100%",
                    }}
                  />
                </div>

                {/* <span
                  className="captcha"
                  style={{
                    fontSize: "29px",
                    fontWeight: "400",
                  }}
                >
                  {generatedCaptcha}
                </span> */}

                <Field
                  className="captcha"
                  fieldKey="generatedCaptcha"
                  field={fields.generatedCaptcha}
                  handleFieldChange={handleFieldChange}
                  value={generatedCaptcha}
                  disabled={true}
                  onKeyDown={handleKeyDown}
                  style={{
                    fontSize: "29px",
                    fontWeight: "400",
                    cursor: "not-allowed",
                    pointerEvents: "none",
                  }}
                />
              </div>

              <div className="col-2">
                <span
                  className="reload"
                  onClick={(event) => {
                    event.stopPropagation();
                    generate();
                  }}
                >
                  <i class="material-icons">loop</i>
                </span>
              </div>
            </div>

            {/* Refresh button */}
          </div>
          <div className="login__field">
            <Field fieldKey="captcha" field={fields.captcha} handleFieldChange={handleFieldChange} />
          </div>
          <div className="login__field">
            <div className="form-group">
              <p> Do you have an account ?</p>
            </div>
          </div>
          <div className="login__field">
            <div className="form-group">
              <Link to="/user/register">
                <span style={{ fontWeight: 600, fontSize: "16px", color: "darkorange" }}> Register </span>
              </Link>
            </div>
          </div>
          <div className="login__field">
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-primary log-sign1"
                style={{ width: "100%" }}
                {...submit}
                onClick={() => {
                  startSMSRecevier();
                }}
              >
                Login
              </button>
              {/* <a href="../dashboard.html" disabled="" className="btn btn-primary log-sign1" role="button" aria-disabled="true"> Login </a> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    //     <div className="rainmaker-displayInline">
    //      {!enableWhatsApp&&
    //     <Card
    //       className={enableWhatsApp?"login-cardwidth user-screens-card":"login-cardwidthmob col-sm-offset-4 col-sm-4 user-screens-card"}
    //       textChildren={
    //         <div>
    //           <div className="rainmaker-displayInline" style={{ justifyContent: "center"  ,alignItems:"center",marginBottom: "24px"}}>
    //             <div style={{ }}>
    //               <Image className="mseva-logo" source={logoUrl?logoUrl:`${logo}`} />
    //             </div >
    //           <div style={{marginLeft:"7px"}}>
    //           <Label bold={true}  fontSize= "23px" label="|" />
    //           </div>
    //            <div style={{marginLeft:"7px" }}>
    //               <Label bold={true} color="black" fontSize= "24px" label="STATE_LABEL" />
    //            </div>
    //           </div>
    //           <Label style={{ marginBottom: "12px" }} className="text-center" bold={true} dark={true} fontSize={16} label="CORE_COMMON_LOGIN" />
    //           <Field fieldKey="phone" field={fields.phone} handleFieldChange={handleFieldChange}  />
    //           <div style={{ marginBottom: "24px", position: "relative", zIndex: 10 }} className="text-right">
    //             <Label id="otp-trigger" className="otp-prompt" label="CORE_LOGIN_NO_ACCOUNT" />
    //             <Link to="/user/register">
    //               <div style={{ display: "inline-block" }}>
    //                 <Label containerStyle={{ cursor: "pointer" }} id="otp-resend" className="otp-resend" label="CORE_REGISTER_HEADING" />
    //               </div>
    //             </Link>
    //           </div>
    //           <Button
    //             {...submit}
    //             style={{
    //               height: "48px",
    //               width:"100%"
    //             }}
    //             variant={"contained"}
    //             color={"primary"}
    // onClick={() => {
    //   startSMSRecevier();
    // }}
    //           >
    //             <Label buttonLabel={true}   labelStyle={{fontWeight:500 }}  label="CORE_COMMON_CONTINUE" />
    //           </Button>
    //           {/* <Button
    //             {...submit}
    //             fullWidth={true}
    //             primary={true}
    //             onClick={(e) => {
    //               startSMSRecevier();
    //             }}
    //           /> */}
    //           {enableWhatsApp&&
    //            <Hidden mdUp>
    //           <div>
    //         <div className="login-hl-divider">
    //        <div className ="login-circle-mobile">
    //        <Label  color="black" fontSize= "16px" label="Or"/>
    //        </div>
    //     </div>
    //     <div className="rainmaker-displayInline login-mobile-whatsapp-button"  onClick={()=>{window.location.href="https://api.whatsapp.com/send?phone=918744960111&text=mSeva-send+this+to+start"}} >
    //         <Icon action="custom" name="whatsapp" className="login-mobile-whatsapp-icon" />
    //         <Label bold={true} color="black" fontSize= "14px" label="WHATSAPP_CONTINUE_MOBILE"/>
    //     </div>
    //     </div>
    //       </Hidden>
    //       }
    //         </div>
    //       }
    //     />
    // }
    // {enableWhatsApp&&

    //     <Hidden mdUp>
    //          <Card
    //       className={enableWhatsApp?"login-cardwidth user-screens-card":"login-cardwidthmob col-sm-offset-4 col-sm-4 user-screens-card"}
    //       textChildren={
    //         <div>
    //           <div className="rainmaker-displayInline" style={{ justifyContent: "center" }}>
    //             <div style={{ marginBottom: "24px" }}>
    //               <Image className="mseva-logo" source={`${logo}`} />
    //             </div >
    //           <div style={{marginLeft:"7px", marginBottom: "24px" }}>
    //           <Label bold={true}  fontSize= "23px" label="|" />
    //           </div>
    //            <div style={{marginLeft:"7px" }}>
    //               <Label bold={true} color="black" fontSize= "24px" label="STATE_LABEL" />
    //            </div>
    //           </div>
    //           <Label style={{ marginBottom: "12px" }} className="text-center" bold={true} dark={true} fontSize={16} label="CORE_COMMON_LOGIN" />
    //           <Field fieldKey="phone" field={fields.phone} handleFieldChange={handleFieldChange}  />
    //           <div style={{ marginBottom: "24px", position: "relative", zIndex: 10 }} className="text-right">
    //             <Label id="otp-trigger" className="otp-prompt" label="CORE_LOGIN_NO_ACCOUNT" />
    //             <Link to="/user/register">
    //               <div style={{ display: "inline-block" }}>
    //                 <Label containerStyle={{ cursor: "pointer" }} id="otp-resend" className="otp-resend" label="CORE_REGISTER_HEADING" />
    //               </div>
    //             </Link>
    //           </div>
    //           <Button
    //             {...submit}
    //             style={{
    //               height: "48px",
    //               width:"100%"
    //             }}
    //             variant={"contained"}
    //             color={"primary"}
    //             onClick={() => {
    //               startSMSRecevier();
    //             }}
    //           >
    //             <Label buttonLabel={true}   labelStyle={{fontWeight:500 }}  label="CORE_COMMON_CONTINUE" />
    //           </Button>
    //           {/* <Button
    //             {...submit}
    //             fullWidth={true}
    //             primary={true}
    //             onClick={(e) => {
    //               startSMSRecevier();
    //             }}
    //           /> */}
    //           {enableWhatsApp&&
    //            <Hidden mdUp>
    //           <div>
    //         <div className="login-hl-divider">
    //        <div className ="login-circle-mobile">
    //        <Label  color="black" fontSize= "16px" label="Or"/>
    //        </div>
    //     </div>
    //     <div className="rainmaker-displayInline login-mobile-whatsapp-button"  onClick={()=>{window.location.href="https://api.whatsapp.com/send?phone=918744960111&text=mSeva-send+this+to+start"}} >
    //         <Icon action="custom" name="whatsapp" className="login-mobile-whatsapp-icon" />
    //         <Label bold={true} color="black" fontSize= "14px" label="WHATSAPP_CONTINUE_MOBILE"/>
    //     </div>
    //     </div>
    //       </Hidden>
    //       }
    //         </div>
    //       }
    //     />
    //     </Hidden>
    // }
    //     {enableWhatsApp&&
    //       <Hidden smDown>
    //           <Card
    //       className="wha-user-screen-card"
    //       textChildren={
    //         <div>
    //           <div className="rainmaker-displayInline" style={{ justifyContent: "center" }}>
    //             <div style={{ marginBottom: "24px" }}>
    //               <Image className="mseva-logo" source={`${logo}`} />
    //             </div >
    //           <div style={{marginLeft:"7px", marginBottom: "24px" }}>
    //           <Label bold={true}  fontSize= "23px" label="|" />
    //           </div>
    //            <div style={{marginLeft:"7px" }}>
    //               <Label bold={true} color="black" fontSize= "24px" label="STATE_LABEL" />
    //            </div>
    //           </div>
    //           <div className="rainmaker-displayInline" style={{ justifyContent: "center" }}>
    //           <div style={{ width: "50%",marginTop:"4%"}}>
    //           <Label style={{ marginBottom: "12px" }} className="text-center" bold={true} dark={true} fontSize={24} label="CORE_COMMON_LOGIN" />
    //           <Field fieldKey="phone" field={fields.phone} handleFieldChange={handleFieldChange}  />
    //           <div style={{ marginBottom: "24px", position: "relative", zIndex: 10 }} className="text-right">
    //             <Label id="otp-trigger" className="otp-prompt" label="CORE_LOGIN_NO_ACCOUNT" />
    //             <Link to="/user/register">
    //               <div style={{ display: "inline-block" }}>
    //                 <Label containerStyle={{ cursor: "pointer" }} id="otp-resend" className="otp-resend" label="CORE_REGISTER_HEADING" />
    //               </div>
    //             </Link>
    //           </div>
    //           <Button
    //             {...submit}
    //             style={{
    //               height: "48px",
    //               width:"100%"
    //             }}
    //             variant={"contained"}
    //             color={"primary"}
    //             onClick={() => {
    //               startSMSRecevier();
    //             }}
    //           >
    //             <Label buttonLabel={true}   labelStyle={{fontWeight:500 }}  label="CORE_COMMON_CONTINUE" />
    //           </Button>
    //           {/* <Button
    //             {...submit}
    //             fullWidth={true}
    //             primary={true}
    //             onClick={(e) => {
    //               startSMSRecevier();
    //             }}
    //           /> */}

    //    </div>
    //      <div className="login-vl-divider">
    //        <div className ="login-circle-web">
    //        <Label  color="black" fontSize= "16px" label="OR"/>
    //        </div>
    //     </div>
    //     <div className="login-qrscan">
    //        <Image className="login-qrlogo" source={`${qrCodeURL}`} />
    //        <div  className="login-qrtext">
    //        <Label  color="black" fontSize= "14px" label="WHATSAPP_SCAN_QR_CODE"/>
    //        </div>
    //     </div>
    //     </div>
    //     </div>
    //       }
    //     />
    //     </Hidden>
    // }
    //     </div>
  );
};

export default LoginForm;



// WEBPACK FOOTER //
// ./src/modules/citizen/User/Login/components/LoginForm/index.js